<app-select
  [data]="data"
  (valueChange)="onChange($event)"
  [textField]="textField"
  [valueField]="valueField"
  [clear]="true"
  [(ngModel)]="value"
>
</app-select>
